module.exports = __webpack_public_path__ + "img/How-Tech-Works-Graphic.30f3c3a3.webp";